var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1166_1168",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1166_1168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 14.1667C14.5139 14.1667 14.809 14.0452 15.0521 13.8021C15.2951 13.5591 15.4167 13.264 15.4167 12.9167C15.4167 12.5695 15.2951 12.2744 15.0521 12.0313C14.809 11.7883 14.5139 11.6667 14.1667 11.6667C13.8194 11.6667 13.5243 11.7883 13.2812 12.0313C13.0382 12.2744 12.9167 12.5695 12.9167 12.9167C12.9167 13.264 13.0382 13.5591 13.2812 13.8021C13.5243 14.0452 13.8194 14.1667 14.1667 14.1667ZM14.1667 16.6667C14.6025 16.6667 14.9997 16.5674 15.3581 16.3686C15.7166 16.1699 16.0096 15.9038 16.2371 15.5705C15.9262 15.3846 15.5972 15.2431 15.25 15.1459C14.9028 15.0487 14.5417 15.0001 14.1667 15.0001C13.7917 15.0001 13.4306 15.0487 13.0833 15.1459C12.7361 15.2431 12.4071 15.3846 12.0962 15.5705C12.3237 15.9038 12.6167 16.1699 12.9752 16.3686C13.3337 16.5674 13.7308 16.6667 14.1667 16.6667ZM10 17.9007C8.19764 17.4092 6.70542 16.3483 5.52333 14.718C4.34111 13.0877 3.75 11.2651 3.75 9.25006V4.45527L10 2.11548L16.25 4.45527V9.17631C16.0556 9.09729 15.8515 9.02596 15.6377 8.96235C15.4241 8.89888 15.2115 8.84895 15 8.81256V5.32548L10 3.4584L5 5.32548V9.25006C5 9.98826 5.10417 10.7092 5.3125 11.4128C5.52083 12.1162 5.80799 12.7738 6.17396 13.3855C6.53979 13.9971 6.97701 14.5463 7.48562 15.033C7.9941 15.5196 8.5459 15.9083 9.14104 16.1988L9.16521 16.1907C9.27521 16.4962 9.41778 16.789 9.59292 17.069C9.76819 17.3489 9.96743 17.6031 10.1906 17.8317C10.1555 17.8424 10.1237 17.854 10.0954 17.8663C10.0671 17.8785 10.0353 17.89 10 17.9007ZM14.1667 17.9167C13.1261 17.9167 12.241 17.5519 11.5112 16.8221C10.7815 16.0924 10.4167 15.2073 10.4167 14.1667C10.4167 13.1262 10.7815 12.241 11.5112 11.5113C12.241 10.7816 13.1261 10.4167 14.1667 10.4167C15.2072 10.4167 16.0924 10.7816 16.8221 11.5113C17.5518 12.241 17.9167 13.1262 17.9167 14.1667C17.9167 15.2073 17.5518 16.0924 16.8221 16.8221C16.0924 17.5519 15.2072 17.9167 14.1667 17.9167Z",
    fill: "black",
    fillOpacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPanel);
export default __webpack_public_path__ + "static/media/adminPanel.7e19bd8c31db4c38127dc99805608386.svg";
export { ForwardRef as ReactComponent };